<template>
  <div class="mt-4">
    <trends-result-chart
      v-if="getTrendsDataSetYes"
      class="pb-2"
      :survey-type="'YES'"
      :dataset="getTrendsDataSetYes"
    ></trends-result-chart>
    <section v-else class="loading-container  position-relative">
      <the-loading />
    </section>

    <trends-result-chart
      v-if="getTrendsDataSetRed"
      class="mt-4"
      :survey-type="'RED'"
      :dataset="getTrendsDataSetRed"
    ></trends-result-chart>
    <section v-else class="loading-container  position-relative">
      <the-loading />
    </section>
  </div>
</template>

<script>
// import TrendsChart from "@/components/dashboard/surveys-charts/group/trends-chart.vue";
import TrendsResultChart from "@/components/dashboard/surveys-charts/group/trends-result-chart.vue";
import { mapGetters } from "vuex";

export default {
  name: "SurveyTrends",
  components: {
    // TrendsChart,
    TrendsResultChart,
  },
  computed: {
    ...mapGetters("mainStats", ["getTrendsDataSetRed", "getTrendsDataSetYes"]),
  },
  methods: {
    async loadTrendsData(type) {
      await this.$store.dispatch("mainStats/trendsData", {
        surveyType: type,
      });
    },
  },
  async mounted() {
    try {
      await this.loadTrendsData("YES");
      await this.loadTrendsData("RED");
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
